import React from 'react'

import Layout from '../../components/layout'

const Team = () => (
  <Layout>
    <div>
      <h1>The Team</h1>
      <p>This is the team page</p>
    </div>
  </Layout>
)

export default Team
